import MalnutritionAPIContext from ".";
import {
  useMalnutritionRiskQuery,
  usePatientWeightsQuery,
} from "../../api/malnutrition/queries";

import type { FC, ReactNode } from "react";

interface MalnutritionAPIContextProviderProps {
  emrPatientID: string;
  emrHospitalID: string;
  children?: ReactNode;
}

const MalnutritionAPIContextProvider: FC<MalnutritionAPIContextProviderProps> = ({
  emrPatientID,
  emrHospitalID,
  children,
}) => {
  const riskAssessmentQuery = useMalnutritionRiskQuery(emrPatientID, emrHospitalID);
  const weightsQuery = usePatientWeightsQuery(emrPatientID, emrHospitalID);

  return (
    <MalnutritionAPIContext.Provider
      value={{
        emrPatientID,
        emrHospitalID,
        riskAssessmentQuery,
        weightsQuery,
      }}
    >
      {children}
    </MalnutritionAPIContext.Provider>
  );
};

export default MalnutritionAPIContextProvider;
